import { render } from "./SpecDetails.vue?vue&type=template&id=0aa3ecd4&scoped=true"
import script from "./SpecDetails.vue?vue&type=script&lang=js"
export * from "./SpecDetails.vue?vue&type=script&lang=js"

import "./SpecDetails.vue?vue&type=style&index=0&id=0aa3ecd4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0aa3ecd4"]])

export default __exports__